
import { shortenLargeNumber } from '@/utils/string'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Ticker',

  props: {
    trendValue: {
      type: [Number, String],
      default: null
    },
    trendPositive: {
      type: Boolean,
      default: null
    },
    isPercent: {
      type: Boolean,
      default: false
    },
    trendDirection: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    iconSize: {
      type: String,
      default: 'small'
    },
    iconClass: {
      type: String,
      default: 'pb-0.5'
    },
    trendHint: {
      type: String,
      default: null
    },
    showBg: {
      type: Boolean,
      default: true
    },
    customBgClass: {
      type: String,
      default: null
    }
  },

  computed: {
    valueDisplay(): string | number {
      if (typeof this.trendValue === 'number') {
        if (this.isPercent) {
          return `${Math.abs(this.trendValue)}%`
        }
        return shortenLargeNumber(Math.abs(this.trendValue))
      }
      return this.trendValue
    },

    bgClass(): string {
      if (this.trendPositive === true) {
        return 'bg-juniper text-juniper'
      }

      if (this.trendPositive === false) {
        return 'bg-cherry text-cherry'
      }

      return 'bg-vanilla-300 text-vanilla-100'
    },

    iconColor(): string {
      if (this.trendPositive === true) {
        return 'juniper'
      }

      if (this.trendPositive === false) {
        return 'cherry'
      }

      return 'vanilla-100'
    }
  }
})
